module.exports = __webpack_public_path__ + "static/media/sc29.33.35.4c5d2761.mp4";